// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3N17K","name":"styles_name__1neZ4","phone":"styles_phone__2RskF"};